module.exports = __webpack_public_path__ + "static/media/Kaitlin Yang Illustrator.0761e67e.jpg";